import React from "react";
import { Modal, VbButton } from "@/components/vb";

type Props = {
    open: boolean;
    onOpenChange: (open: boolean) => void;
    title: string;
    description?: React.ReactNode;
    children?: React.ReactNode;
    confirmLabel: string;
    pendingLabel?: string;
    cancelLabel?: string;
    /** Destructive confirmations get the danger button. */
    destructive?: boolean;
    pending?: boolean;
    confirmDisabled?: boolean;
    onConfirm: () => void;
};

/** One confirm dialog for the settings surface, on the shared v2 modal.
 *  Replaces the five near-identical shadcn confirm dialogs the workspace panel
 *  hand-rolled (remove member, cancel invitation, delete workspace, rename
 *  company, delete company). */
export function ConfirmDialog({
    open,
    onOpenChange,
    title,
    description,
    children,
    confirmLabel,
    pendingLabel,
    cancelLabel = "Cancel",
    destructive,
    pending,
    confirmDisabled,
    onConfirm,
}: Props) {
    return (
        <Modal
            open={open}
            onOpenChange={onOpenChange}
            title={title}
            description={description}
            widthClassName="max-w-md"
            footer={
                <>
                    <VbButton
                        type="button"
                        variant="secondary"
                        onClick={() => onOpenChange(false)}
                        disabled={pending}
                    >
                        {cancelLabel}
                    </VbButton>
                    <VbButton
                        type="button"
                        variant={destructive ? "danger" : "primary"}
                        onClick={onConfirm}
                        disabled={pending || confirmDisabled}
                    >
                        {pending ? (pendingLabel ?? "Working…") : confirmLabel}
                    </VbButton>
                </>
            }
        >
            {children}
        </Modal>
    );
}

export default ConfirmDialog;
